import { Search } from '@shinetools/lumen-react'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useDebouncedSearchInput } from '../../../../hooks'
import { ExpertProfitAndLossExportMenu } from '../ExpertProfitAndLossExportMenu'
import * as Styled from './styles'

interface ExpertProfitAndLossToolbarProps {
  search: string
  setSearch: (value: string) => void
}

export const ExpertProfitAndLossToolbar = ({ search, setSearch }: ExpertProfitAndLossToolbarProps): ReactElement => {
  const { t } = useTranslation()

  const handleSearchUpdate = useCallback(
    (value: string) => {
      setSearch(value)
    },
    [setSearch],
  )

  const { onChange: handleSearchChange, value: searchValue } = useDebouncedSearchInput(search, handleSearchUpdate)

  return (
    <Styled.ToolbarWrapper>
      <Styled.SearchWrapper>
        <Search
          rounded
          noDropdown
          onChange={handleSearchChange}
          placeholder={t('expert_profit_and_loss.toolbar.search.placeholder')}
          size="small"
          value={searchValue}
        />
      </Styled.SearchWrapper>
      <ExpertProfitAndLossExportMenu />
    </Styled.ToolbarWrapper>
  )
}
